import React from "react";
import { Thermometer } from "lucide-react";
import { CONSTANTS } from "../data";

interface TemperatureControlProps {
  enabled: boolean;
  currentTemp: number;
  onTempChange: (temp: number) => void;
  recipeId?: string;
  containerWidth?: number;
  containerPadding?: number;
}

const TemperatureControl: React.FC<TemperatureControlProps> = ({
  enabled,
  currentTemp,
  onTempChange,
  recipeId,
  containerWidth = 320,
  containerPadding = 16,
}) => {
  if (!enabled) return null;

  const optimalRange = recipeId
    ? CONSTANTS.TEMPERATURE_CONTROL.optimalRanges[recipeId]
    : null;

  // Calculate responsive sizing based on container
  const iconSize = Math.max(12, Math.min(20, containerWidth * 0.05));
  const fontSize = Math.max(10, Math.min(16, containerWidth * 0.04));
  const padding = Math.max(6, Math.min(12, containerPadding * 0.5));

  return (
    <div className="bg-bg-main rounded-lg border border-border-color" style={{ padding: `${padding}px` }}>
      <div className="flex items-center gap-2 mb-2">
        <Thermometer size={iconSize} className="text-primary-action" />
        <span className="font-semibold text-text-primary" style={{ fontSize: `${fontSize}px` }}>
          {containerWidth < 200 ? 'Temp' : 'Temperature Control'}
        </span>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-text-secondary" style={{ fontSize: `${Math.max(8, fontSize - 2)}px` }}>Cold</span>
        <input
          type="range"
          min="0"
          max="100"
          value={currentTemp}
          onChange={(e) => onTempChange(parseInt(e.target.value))}
          className="flex-1"
          style={{ height: `${Math.max(8, containerWidth * 0.03)}px` }}
        />
        <span className="text-text-secondary" style={{ fontSize: `${Math.max(8, fontSize - 2)}px` }}>Hot</span>
        <span className="font-bold text-text-primary" style={{ 
          fontSize: `${Math.max(8, fontSize - 2)}px`,
          minWidth: `${Math.max(24, containerWidth * 0.08)}px`
        }}>
          {currentTemp}°
        </span>
      </div>
      {optimalRange && (
        <div className="text-text-secondary mt-1" style={{ fontSize: `${Math.max(7, fontSize - 4)}px` }}>
          Optimal: {optimalRange.min}°-{optimalRange.max}°
        </div>
      )}
    </div>
  );
};

export default TemperatureControl;
